import { Entity } from 'typeorm';
import { FinalGrade } from './final-grade.entity';

@Entity()
export class FinalGradeModification {
    item: FinalGrade;
    changedFields: ("writtenGrade" | "oralGrade" | "finalGrade" | "note" | "floor")[] = [];
}
